import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeBranchId, setActiveBranchId] = useState(null);

  useEffect(() => {
    const t = sessionStorage.getItem("nx_token");
    const u = sessionStorage.getItem("nx_user");
    const b = sessionStorage.getItem("nx_branch");
    if (t && u) {
      setToken(t);
      setUser(JSON.parse(u));
      if (b) setActiveBranchId(b);
    }
    setLoading(false);
  }, []);

  const persist = (tok, usr) => {
    sessionStorage.setItem("nx_token", tok);
    sessionStorage.setItem("nx_user", JSON.stringify(usr));
    setToken(tok);
    setUser(usr);
  };

  const login = useCallback(async (email, password) => {
    const { data } = await apiClient.post("/auth/login", { email, password });
    persist(data.access_token, data.user);
    return data.user;
  }, []);

  const loginGoogleSession = useCallback(async (session_id) => {
    const { data } = await apiClient.post("/auth/google/session", { session_id });
    persist(data.access_token, data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem("nx_token");
    sessionStorage.removeItem("nx_user");
    sessionStorage.removeItem("nx_branch");
    setToken(null);
    setUser(null);
    setActiveBranchId(null);
  }, []);

  const setBranch = (bid) => {
    setActiveBranchId(bid);
    if (bid) sessionStorage.setItem("nx_branch", bid);
    else sessionStorage.removeItem("nx_branch");
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, loginGoogleSession, logout, activeBranchId, setBranch }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
